
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { format, parseISO } from 'date-fns';

 



const ConsumptionBarChart = ({ data, selectedRange, customRange ,title,color ,type,prepareBarChartData,height }) => {
  
  const CustomTooltip = ({ active, payload, label, title, color }) => {
    if (!active || !payload || !payload.length || 
      !payload.some(p => p.value > 0)) {
      return null;
    }
    if (active && payload && payload.length) {
      return (
        <div style={{ 
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          zIndex: 9999 ,
          position: 'relative',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <div style={{ marginBottom: '4px', fontSize: '11px', color: '#666' }}>
            {label}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ 
              width: '12px', 
              height: '12px', 
              backgroundColor: color,
              borderRadius: '2px'
            }} />
            <span>{title}: {payload[0].value}</span>
          </div>
        </div>
      );
    }
    return null;
  };
  

  const chartData = prepareBarChartData(type);
  return (
    
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={chartData}
        margin={{
          top: 30,
          right: 0,
          bottom: 0,
          left: 2,
        }}
        barCategoryGap="5%"
        barGap={2}
      >
        {/* <text
          x={30}
          y={15}
          textAnchor="start"
          style={{
            fontSize: '12px',
            fill: '#333',
            fontWeight: 'bold'
          }}
        >
          {title}
        </text> */}
        <CartesianGrid 
          strokeDasharray="0 0"  // Makes lines solid instead of dotted
          horizontal={true}      // Show horizontal lines
          vertical={false}  
        />
        <XAxis 
          dataKey="date"
          angle={0}
          height={60}
          interval={0}
          axisLine={false}  // Removes the axis line
          tickLine={false} 
          tickFormatter={(value) => {
              const firstDate = chartData[0] && chartData[0].date;
              const lastDate = chartData[chartData.length - 1] && chartData[chartData.length - 1].date;
              const dateObj = typeof value === 'string' ? parseISO(value) : new Date(value);
              if (value === firstDate || value === lastDate) {
              return format(dateObj, 'MMM d');
              }
              return "";
          }}

          tick={{ 
            fontSize: 9 // Reduced font size
          }}
        />
        <YAxis 
          axisLine={false}  // Removes the axis line
          tickLine={false}  // Removes the tick lines
          tick={{ 
            fontSize: 9,    // Matches your XAxis font size
            fill: '#666'    // Sets the label color
          }}
        />
        <Tooltip 
          cursor={false}
          // contentStyle={{
          //   backgroundColor: '#fff',
          //   border: '1px solid #ccc',
          //   borderRadius: '4px',
          //   padding: '8px'
          // }}
          content={<CustomTooltip title={title} color={color} />}
        />
        <Bar 
          dataKey="value" 
          fill={color} 
          barSize={20}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ConsumptionBarChart;